// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__OI1HG","head__title--text":"styles_head__title--text__2bLxV"};